import { StateCreator } from 'zustand';
import { GameState } from '../gameStore';

export interface TimerSlice {
  playerTimeRemaining: number;
  modelTimeRemaining: number;
  gameTimeLimit: 3 | 5 | 10;
  activePlayer: 'player' | 'model';
  timeOut: 'player' | 'model' | null;
  decrementTimer: () => void;
  switchActivePlayer: () => void;
  setGameTimeLimit: (minutes: 3 | 5 | 10) => void;
}

export const createTimerSlice: StateCreator<
  GameState,
  [],
  [],
  TimerSlice
> = (set, get) => ({
  playerTimeRemaining: 180,
  modelTimeRemaining: 180,
  gameTimeLimit: 3,
  activePlayer: 'player',
  timeOut: null,
  
  decrementTimer: () => {
    const { activePlayer, game } = get();
    if (game.isGameOver()) {
      return;
    }
    
    if (activePlayer === 'player') {
      set((state) => {
        if (state.playerTimeRemaining <= 0.1) {
          return { 
            playerTimeRemaining: 0,
            timeOut: 'player',
          };
        }
        
        return { 
          playerTimeRemaining: Math.max(0, state.playerTimeRemaining - 0.1) 
        };
      });
    } else {
      set((state) => {
        if (state.modelTimeRemaining <= 0.1) {
          return { 
            modelTimeRemaining: 0,
            timeOut: 'model',
          };
        }
        
        return { 
          modelTimeRemaining: Math.max(0, state.modelTimeRemaining - 0.1) 
        };
      });
    }
  },
  
  switchActivePlayer: () => {
    set((state) => ({ 
      activePlayer: state.activePlayer === 'player' ? 'model' : 'player' 
    }));
  },

  setGameTimeLimit: (minutes: 3 | 5 | 10) => {
    const timeInSeconds = minutes * 60;
    console.log(`Setting game time limit to ${minutes} minutes (${timeInSeconds} seconds)`);
    set({
      gameTimeLimit: minutes,
      playerTimeRemaining: timeInSeconds,
      modelTimeRemaining: timeInSeconds
    });
  },
});